import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Button, Row, Col } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import user_icon from "../../../Assets/svg/user_icon.svg";
import email_icon from "../../../Assets/svg/email_icon.svg";
import show_eye_icon from "../../../Assets/svg/show_eye_icon.svg";
import hide_eye_icon from "../../../Assets/svg/hide_eye_icon.svg";
import password_icon from "../../../Assets/svg/password_icon.svg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { post } from "helpers/api_helper";
import toast from "react-hot-toast";
import { registerSchema } from "helpers/yup_validator";

const SignUp = () => {
  const navigate = useNavigate();
  const [pass, setPass] = useState(false);
  const [phone, setPhone] = useState("");

  const handlePass = () => {
    setPass(!pass);
  };

  const handleSubmit = async (
    values,
    { setSubmitting, setErrors, setStatus }
  ) => {
    try {
      const response = await post("/user/register", values);
      if (response.success) {
        toast.success(response?.message || "Registered successfully");
        navigate("/otp-verification", { state: { userData: values } });
      } else {
        setStatus({ server: response?.message || "Email Already Exists" });
        toast.error(response?.message || "Email Already Exists");
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || error?.response?.data?.error ||
        error?.message ||
        "Error during user registration";
      setStatus({ server: errorMessage });
      toast.error(errorMessage);
      console.error("Error during user registration:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Navigate to="/login" />
  )

  return (
    <div className="formInner">
      <div className="top py-2 text-center">
        <h2 className="m-0 fw-sbold head">Welcome Sign Up!</h2>
        <p className="m-0 py-1">Please enter your details</p>
      </div>
      <Formik
        initialValues={{
          name: "",
          phone: "",
          email: "",
          password: "",
          termsAccepted: false,
        }}
        validationSchema={registerSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, isSubmitting, status }) => (
          <FormikForm>
            <Row>
              <Col lg="12" className="my-3">
                <div className="position-relative labelInput">
                  <div className="iconWithText position-relative">
                    <Field
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Full Name"
                    />
                    <span
                      className="icn position-absolute"
                      style={{ left: "8px" }}
                    >
                      <img src={user_icon} alt="user icon" />
                    </span>
                  </div>
                  <label
                    htmlFor="name"
                    className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                  >
                    Full Name
                  </label>
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </Col>
              <Col lg="12" className="my-3">
                <div className="position-relative labelInput">
                  <div className="iconWithText position-relative">
                    <PhoneInput
                      country={"us"}
                      value={phone}
                      onChange={(newPhone) => {
                        setPhone(newPhone);
                        setFieldValue("phone", newPhone);
                      }}
                    />
                  </div>
                  <label
                    htmlFor="phone"
                    className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                  >
                    Phone Number
                  </label>
                  <ErrorMessage
                    name="phone"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </Col>
              <Col lg="12" className="my-3">
                <div className="position-relative labelInput">
                  <div className="iconWithText position-relative">
                    <Field
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="abc@gmail.com"
                    />
                    <span
                      className="icn position-absolute"
                      style={{ left: "8px" }}
                    >
                      <img src={email_icon} alt="email icon" />
                    </span>
                  </div>
                  <label
                    htmlFor="email"
                    className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                  >
                    Email
                  </label>
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </Col>
              <Col lg="12" className="my-3">
                <div className="position-relative labelInput">
                  <div className="iconWithText position-relative">
                    <Field
                      type={pass ? "text" : "password"}
                      name="password"
                      className="form-control"
                      placeholder="********"
                    />
                    <span
                      className="icn position-absolute"
                      style={{ left: "8px" }}
                    >
                      <img src={password_icon} alt="password icon" />
                    </span>
                    <Button
                      onClick={handlePass}
                      variant="transparent"
                      className="border-0 p-0 icn position-absolute"
                      style={{ right: "8px" }}
                    >
                      {pass ? (
                        <img src={show_eye_icon} alt="show password" />
                      ) : (
                        <img src={hide_eye_icon} alt="hide password" />
                      )}
                    </Button>
                  </div>
                  <label
                    htmlFor="password"
                    className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                  >
                    Password
                  </label>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </Col>

              <Col lg="12" className="my-3">
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="termsAccepted"
                    className="form-check-input"
                    id="termsAccepted"
                  />
                  <label className="form-check-label" htmlFor="termsAccepted">
                    I accept the{" "}
                    <Link
                      to="/terms-and-conditions"
                      className="themeClr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms and Conditions
                    </Link>
                  </label>
                  <ErrorMessage
                    name="termsAccepted"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </Col>

              {status && status.server && (
                <Col lg="12" className="my-3">
                  <div className="text-danger">{status.server}</div>
                </Col>
              )}

              <Col lg="12" className="my-3">
                <Button
                  type="submit"
                  className="d-flex align-items-center justify-content-center w-100 commonBtn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Signing up..." : "SIGN UP"}
                </Button>
                <div className="text-center mt-3">
                  <p className="m-0 fw-sbold">
                    Already have an account?{" "}
                    <Link className="themeClr" to={"/login"}>
                      Login
                    </Link>
                  </p>
                </div>
              </Col>
            </Row>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
};

export default SignUp;
